import React from "react";
import Banner from "../common/Banner";
import contactData from "../../data/contact.json";
import images from "../../assets/images/Constant";

export default function ContactPage() {
  const enquiry = contactData?.enquiry || {};
  const infoCards = enquiry?.infoCards || [];

  return (
    <>
      <Banner
        title={contactData?.banner?.title || "Contact"}
        currentLabel={contactData?.banner?.breadcrumb || "Contact"}
      />

      {/* OFFICES */}
      {/* <section className="max-w-[1200px] mx-auto px-6 py-16">
        <div className="text-center">
          <div className="flex items-center justify-center gap-3 text-primary py-2 font-semibold tracking-widest text-sm">
            <span>{contactData?.offices?.eyebrow}</span>
          </div>
          <h2 className="mt-2 text-3xl md:text-[40px] font-semibold text-dark">
            {contactData?.offices?.title}
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
          {offices.map((o, idx) => (
            <div
              key={o.id || idx}
              className={`bg-[#F4F4F4] border border-[#EEEEEE] shadow-[0_8px_25px_rgba(0,0,0,0.10)] px-8 py-8 mt-10 text-center ${
                idx === 1
                  ? "relative z-20 md:-translate-y-10 shadow-[0_22px_55px_rgba(0,0,0,0.22)]"
                  : ""
              }`}
            >
              <div className="mx-auto w-[110px] h-[110px] rounded-full bg-white border border-[#E6E6E6] flex items-center justify-center text-[56px] shadow-sm">
                <span aria-hidden="true">{o.flag}</span>
              </div>

              <h3 className="mt-6 text-[20px] font-semibold text-[#0b2c3d]">
                {o.country}
              </h3>
              <p className="mt-2 text-sm text-[#9CA3AF]">{o.address}</p>

              <div className="mt-6 text-sm text-[#6B7280] space-y-2">
                <p>
                  <span className="font-semibold text-[#0b2c3d]">Email:</span>{" "}
                  {o.email}
                </p>
                <p>
                  <span className="font-semibold text-[#0b2c3d]">
                    Contact No.:
                  </span>{" "}
                  {o.phone}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      {/* ENQUIRY */}
      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 pt-12 sm:pt-20 pb-16 sm:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6">
            {infoCards.map((c, idx) => (
              <div
                key={`${c.title}-${idx}`}
                className="flex gap-5 bg-[#F4F4F4] border border-[#EDEDED] p-5"
              >
                <div className="w-10 h-10 flex items-center justify-center shrink-0">
                  
                    <img src={images[c.icon]} alt=""  className=""/>
                    
                
                </div>  

                <div>
                  <p className="text-xs font-semibold text-[#0b2c3d] tracking-widest">
                    {c.title}
                  </p>
                  <p className="mt-2 text-sm text-[#9CA3AF] leading-relaxed">
                    {c.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="">
            <div className="flex gap-2 ">
  <img src={images[enquiry.icon]} alt=""  className=""/>
          <span className="text-base md:text-[22px] uppercase tracking-widest font-medium text-primary">
            {enquiry.rightEyebrow}
          </span>
</div>
            <h3 className="mt-2 text-3xl md:text-[40px] font-semibold leading-tight text-dark">
              {enquiry.rightTitle}
            </h3>

            <div className="mt-4 space-y-4 text-light text-sm leading-relaxed">
              {(enquiry.rightDescription || []).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
